import { render, staticRenderFns } from "./PurchaserContractForm.vue?vue&type=template&id=b10c88c8&scoped=true&"
import script from "./PurchaserContractForm.vue?vue&type=script&lang=ts&"
export * from "./PurchaserContractForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10c88c8",
  null
  
)

export default component.exports